import client, { clientWithCredentials } from './client'
import gqlClient from './gqlClient'
import { applyHooks } from './hooks'
// import mobileAndTabletCheck from '../utils/mobileAndTabletcheck'

const applyFilter = call => call.then(res => applyHooks(res))

// const subscriptionOriginType = mobileAndTabletCheck()
//   ? 'customer_web_mobile'
//   : 'customer_web_desktop'

// Recovery Password
/**
 * @param {string} email user email
 */
export const recoverPassword = ({ email }) =>
  applyFilter(client(`user/recover`, 'post', { email }))

// LOG IN
/**
 * @param {string} email user email
 * @param {string} password user password
 */
export const logIn = ({ email, password }) =>
  applyFilter(
    clientWithCredentials(
      `login`,
      'post',
      { username: email, password },
      process.env.REACT_APP_SUBSCRIPTION_API_URL
    )
  )

export const signUp = ({ email, password, firstname, lastname }) => {
  return gqlClient.publicMutation(
    `
    mutation signUp($email: String!, $password: String!, $firstname: String!, $lastname: String!) {
      signUp(email: $email, password: $password, firstname: $firstname, lastname: $lastname) {
        ... on UserType {
          id
          email
          firstname
          lastname
          store_id
          credits
          postcode
          created_at
          updated_at
          __typename
        }
        ... on GenericError {
          error
          __typename
        }
        __typename
      }
    }
    `,
    { email, password, firstname, lastname }
  )
}

// CHECK AUTH
export const checkAuth = () =>
  clientWithCredentials(
    `check-auth`,
    'get',
    null,
    process.env.REACT_APP_SUBSCRIPTION_API_URL
  )

// LOG OUT
export const logout = () =>
  clientWithCredentials(
    `logout`,
    'get',
    null,
    process.env.REACT_APP_SUBSCRIPTION_API_URL
  )

export const getUpcomingDays = ({ zipcode }) => {
  return gqlClient.publicQuery(
    `
    query getUpcomingDays($zipcode: String!) {
      upcomingDays (zipcode: $zipcode, weeks: 2) {
        available
        date
        displayDate
        cutoff {
          time
          utcOffset
          userTimeZone
        }
      }
    }
    `,
    { zipcode }
  )
}

export const getTimeslots = ({ zipcode }) => {
  return gqlClient.publicQuery(
    `
    query getTimeslots($zipcode: String!) {
      timeslots(zipcode: $zipcode) {
        start
        end
        label
        available
      }
    }
    `,
    { zipcode }
  )
}

export const getMenu = ({ zipcode, date }) => {
  return gqlClient.publicQuery(
    `
    query getMenu($date: String!, $zipcode:String!) {
      menu(date: $date zipcode: $zipcode) {
        available
        categories {
          id
          title
          label
          subtitle
          image
          imagePng
          meals {
            id
            sku
            name
            category_id
            new_meal
            new_chef
            chef_firstname
            chef_lastname
            chef_id
            logopic
            country_of_manufacture
            calories
            price
            short_description
            image
            small_image
            thumbnail
            image_path
            stock
            inStock
            meat_type
            reviews
            rating
            stars
            weight
            available_from_date
            specifications_detail {
              id
              label
              image
              image_png
            }
            images {
              x300
              x600
              x900
              x1200
            }
          }
        }
      }
    }        
    `,
    { zipcode, date }
  )
}

export const getOrderSummary = ({ date, products, zipcode }) => {
  return gqlClient.publicMutation(
    `
    mutation orderSummary($date: String!, $products: [OrderItemInput]!, $zipcode: String!) {
      orderSummary(date: $date, products: $products, zipcode: $zipcode) {
        ... on GenericError {
          error
        }
        ... on CartSummary {
          id
          tip
          taxes
          subtotal
          discount
          shipping
          grandTotal
          coupon
          giftcard
          giltcode
        }
      }
    }    
    `,
    {
      date,
      products,
      zipcode
    }
  )
}

export const getCards = () => {
  return gqlClient.query(
    `
    {
      cards {
        id
        owner
        last4
        brand
        cardId
        customer
        expYear
        expMonth
      }
    }
    `
  )
}

/*
"cardInfo": {
  "firstname"
  "lastname"
  "card"
  "month"
  "year"
  "code"
}
*/

export const createCard = cardInfo => {
  return gqlClient.mutation(
    `
    mutation addCard($cardInfo: CardInput!) {
      addCard(cardInfo: $cardInfo) {
        __typename
        ... on GenericError {
          error
        }
        ... on CardType {
          id
          owner
          brand
          last4
          cardId
          customer
          expYear
          expMonth
          __typename
        }
      }
    }
    `,
    { cardInfo }
  )
}

export const removeCard = id => {
  return gqlClient.mutation(
    `
    mutation removeCard($id: String!) {
      removeCard(id: $id){
        __typename
        ... on GenericError {
          error
        }
        ... on cardListType {
          cards {
            id
            brand
            last4
            owner
            cardId
            customer
            expYear
            expMonth
          }
        }
      }
    }
    `,
    {
      id
    }
  )
}

export const getAddresses = () => {
  return gqlClient.query(
    `
    {
      addresses {
        id
        isActive
        city
        country
        region
        regionId
        postcode
        telephone
        street
      }
    }
    `
  )
}

/*
"address": {
  "city"
  "zipcode"
  "phone"
  "street"
  "floor"
  "state"
}
*/

export const createAddress = address => {
  return gqlClient.mutation(
    `
    mutation saveAddress($address: AddressInput!){
      saveAddress(addressInfo: $address) {
        __typename
        ... on GenericError {
          error
        }
        ... on AddressType {
          id
          isActive
          city
          country
          region
          regionId
          postcode
          telephone
          street
          regionId
        }
      }
    }
    `,
    { address }
  )
}

/*
"address": {
  "id"
  "city"
  "zipcode"
  "phone"
  "street"
  "floor"
  "state"
}
*/

export const updateAddress = address => {
  return gqlClient.mutation(
    `
    mutation saveAddress($address: AddressInput!) {
      saveAddress(addressInfo: $address) {
        __typename
        ... on GenericError {
          error
        }
        ... on AddressType {
          id
          isActive
          city
          country
          region
          regionId
          postcode
          telephone
          street
          regionId
        }
      }
    }
    `,
    { address }
  )
}

export const removeAddress = id => {
  return gqlClient.mutation(
    `
    mutation removeAddress($id: String!) {
      removeAddress(id: $id) {
        __typename
        ... on GenericError {
          error
          __typename
        }
        ... on addressListType {
          addresses {
            id
            isActive
            city
            country
            region
            regionId
            postcode
            telephone
            street
            regionId
          }
        }
      }
    }
    `,
    { id }
  )
}

/*
{
	"origin": "customer_web",
	"order": {
		"tip"
		"start"
		"end"
		"cardId"
		"quoteId"
		"addressId"
		"comments"
		"products": [
			{
				"id"
				"qty"
			}
		],
		"deliveryDate"
	}
}
*/

export const createOrder = order => {
  return gqlClient.mutation(
    `
    mutation createOrder($origin: OriginInput!, $order: OrderInput!) {
      createOrder(origin: $origin, order: $order) {
        ... on GenericError {
          error
        }
        ... on OrderType {
          id
          quoteId
          comment
          timeStart
          timeEnd
          deliveryDate
          subtotal
          discount
          tip
          taxes
          shipping
          grandTotal
          totalPaid
          totalInvoiced
          orderStatus {
            state
            status  
          }  
        }
      }
    }
    `,
    {
      origin: 'customer_web',
      order
    }
  )
}

export const getUserInfo = () => {
  return gqlClient.query(
    `
    {
      profile {
        id
        email
        firstname
        lastname
        store_id
        credits
        postcode
        created_at
        updated_at
      }
    }    
    `
  )
}

export const applyCoupon = ({ code, quote }) => {
  return gqlClient.mutation(
    `
    mutation applyCoupon($code: String!, $quote: String!) {
      applyCoupon(code: $code, quote: $quote) {
        __typename
        ... on GenericError {
          error
        }
        ... on CartSummary {
          id
          tip
          taxes
          subtotal
          discount
          shipping
          grandTotal
          coupon
          giftcard
          giltcode
        }
      }
    }
    `,
    {
      code,
      quote
    }
  )
}

export const getMealDetail = ({ meal_id }) => {
  return gqlClient.publicQuery(
    `
    query getMeal($id: Int!) {
      meal(id: $id) {
        id
        name
        image {
          fullPath
          image
          smallImage
          thumbnail
        }
        rating
        stars
        price
        logopic
        chefFirstname
        chefLastname
        sku
        category
        chefId
        chefImage
        mealStory
        stock
        shortDescription
        chefLogo
        inStock
        urlPath
        meatType
        mealStory
        originalPrice
        priceIncludingTax
        basePriceIncludingTax
        specificationsDetail {
          id
          label
          image
          imagePng
        }
        nutritionInfo {
          fat
          carbs
          fiber
          sugar
          sodium
          protein
          calories
          servingSize
          saturatedFat
        }
        ingredients {
          id
          name
          value
          componentCode
          description
          filename
          image
          manufacturer
        }
        cookingSteps {
          ovenStepsWithoutSealing
          microwaveStepsWithoutSealing
          ovenSteps
          microwaveSteps
        }
        reviews {
          id
          createdAt
          status
          detail
          title
          detail
          nickname
          customerId
          customerName
          reviews
          rating
          stars
          image
        }
      }
    }    
    `,
    {
      id: +meal_id
    }
  )
}



// WEBPACK FOOTER //
// ./src/api/index.js